import Component from 'flarum/Component';
import IndexPage from 'flarum/components/IndexPage';
import listItems from 'flarum/helpers/listItems';

/* global m */

export default class PageContainer extends Component {
    init() {
        super.init();
    }

    view() {
        const pageClass = '.FormulairePage' + (this.props.noTheme ? '' : '.FormulaireTheme');

        const {
            showSideNav = true,
            narrow = false,
        } = this.props;

        if (showSideNav) {
            return m('.FormulairePageContainer', m('.container', m('.sideNavContainer', [
                m('nav.IndexPage-nav.sideNav', m('ul', listItems(IndexPage.prototype.sidebarItems().toArray()))),
                m('.sideNavOffset', m(pageClass, this.props.children)),
            ])));
        }

        return m('.FormulairePageContainer', m(narrow ? '.containerNarrow' : '.container', m(pageClass, this.props.children)));
    }
}
